"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@chakra-ui/icons");
var _react = require("@chakra-ui/react");
var _react2 = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var ScrollButton = _ref => {
  var {
    direction,
    onClick
  } = _ref;
  var ArrowIcon = direction === 'left' ? _icons.ChevronLeftIcon : _icons.ChevronRightIcon;
  return (0, _jsxRuntime.jsx)(_react.Button, {
    onClick: onClick,
    "aria-label": "".concat(direction, " scroll button"),
    rounded: "full",
    w: "36px",
    h: "36px",
    minW: "unset",
    p: 0,
    mx: 1,
    mt: '20px',
    bg: "transparent",
    color: "#58595B",
    _hover: {
      bg: '#026575',
      color: '#ffffff'
    },
    _active: {
      bg: 'rgba(2, 101, 117, 0.2)',
      color: '#026575',
      transform: 'scale(0.95)'
    },
    _focus: {
      outline: 'none'
    },
    _focusVisible: {
      outline: '2px solid #026575',
      outlineOffset: '2px'
    },
    transition: "all 0.1s ease-in-out",
    children: (0, _jsxRuntime.jsx)(_react.Icon, {
      as: ArrowIcon,
      boxSize: 6
    })
  });
};
var _default = exports.default = ScrollButton;